import { mockData } from "./Mock";
import { InvoiceRequest, InvoiceRecord } from "../../models/InvoiceManagement";

const mockOrderItems = [
    {
        orderId: "ORD001",
        productName: "企业级云服务套餐",
        sellerId: "SELLER001",
        sellerName: "云服务提供商A",
        skuType: 1
    },
    {
        orderId: "ORD002",
        productName: "数据分析工具",
        sellerId: "SELLER002",
        sellerName: "数据科技公司B",
        skuType: 0
    }
];

const mockUnprocessedRequests: InvoiceRequest[] = [
    {
        id: "INV001",
        buyerId: "BUYER001",
        buyerName: "北京科技有限公司",
        amount: 5000.00,
        title: "北京科技有限公司",
        taxNumber: "91110000123456789X",
        bankName: "中国工商银行北京分行",
        bankAccount: "1234567890123456789",
        address: "北京市朝阳区科技园区123号",
        phone: "010-12345678",
        status: "pending",
        orderItems: mockOrderItems,
        emailAddress: "finance@beijingtech.com",
        invoiceType: "1"
    },
    {
        id: "INV002",
        buyerId: "BUYER002",
        buyerName: "上海贸易有限公司",
        amount: 3200.00,
        title: "上海贸易有限公司",
        taxNumber: "91310000123456789Y",
        bankName: "中国建设银行上海分行",
        bankAccount: "9876543210987654321",
        address: "上海市浦东新区贸易大厦456号",
        phone: "021-87654321",
        status: "pending",
        orderItems: [mockOrderItems[0]],
        emailAddress: "accounting@shanghaitrade.com",
        invoiceType: "0"
    }
];

const mockProcessedInvoices: InvoiceRecord[] = [
    {
        id: "INV003",
        invoiceRequestId: "INV003",
        buyerId: "BUYER003",
        buyerName: "广州制造企业",
        amount: 8000.00,
        title: "广州制造企业",
        taxNumber: "91440000123456789Z",
        bankName: "中国农业银行广州分行",
        bankAccount: "1122334455667788990",
        address: "广州市天河区工业园789号",
        phone: "020-11223344",
        status: "1",
        orderItems: mockOrderItems,
        emailAddress: "finance@guangzhou.com",
        invoiceNumber: "FP2024001",
        invoiceType: "1"
    },
    {
        id: "INV004",
        invoiceRequestId: "INV004",
        buyerId: "BUYER004",
        buyerName: "深圳软件公司",
        amount: 15000.00,
        title: "深圳软件公司",
        taxNumber: "91440300123456789W",
        bankName: "招商银行深圳分行",
        bankAccount: "9988776655443322110",
        address: "深圳市南山区软件园321号",
        phone: "0755-99887766",
        status: "1",
        orderItems: [mockOrderItems[1]],
        emailAddress: "billing@shenzhen.com",
        invoiceNumber: "FP2024002",
        invoiceType: "0"
    }
];

mockData.set("unprocessed_requests", mockUnprocessedRequests);
mockData.set("processed_invoices", mockProcessedInvoices);
